import { createSlice } from "@reduxjs/toolkit";
import {
  AddEmojiAction,
  DeleteEmojiAction,
  GetAllEmojiAction,
} from "store/middlewares/dataManagement/emoji";

export const emojiSlice = createSlice({
  name: "emoji",
  initialState: {
    emojiLoading: true,
    emoji: null,
    addEmojiLoading: false,
  },
  extraReducers(builder) {
    builder
      // Get all emojis
      .addCase(GetAllEmojiAction.pending, (state) => {
        state.emojiLoading = true;
      })
      .addCase(GetAllEmojiAction.fulfilled, (state, action) => {
        state.emojiLoading = false;
        state.emoji = action.payload.response;
      })
      .addCase(GetAllEmojiAction.rejected, (state) => {
        state.emojiLoading = false;
        state.emoji = null;
      })
      // Add emoji
      .addCase(AddEmojiAction.pending, (state) => {
        state.addEmojiLoading = true;
      })

      .addCase(AddEmojiAction.fulfilled, (state, action) => {
        state.addEmojiLoading = false;
        state.emoji = {
          ...state.emoji,
          total: Number(state.emoji?.total || 0) + 1,
          data: [action.payload.response, ...(state.emoji?.data || [])],
        };
      })
      .addCase(AddEmojiAction.rejected, (state) => {
        state.addEmojiLoading = false;
      })
      // Delete emoji
      .addCase(DeleteEmojiAction.fulfilled, (state, action) => {
        state.emojiLoading = false;
        state.emoji = action.payload.response; // or update optimistically
      });
  },
});

export default emojiSlice.reducer;
